import { api } from '@/shared/api/client-api'
import { API_END_POINTS } from '@/shared/api/end-points'
import { GetProjectStatistics } from '@/shared/api/end-points/project'
import { StatisticsResponse } from '../../lib'

const getstatistics = async (params: GetProjectStatistics) => {
  return await api.json<StatisticsResponse>(API_END_POINTS.project.getStatistics(params))
}

export default getstatistics
